export const CONST_NAMES = {
  SYSTEM_LANGUAGE: "SYSTEM_LANGUAGE",
};
